export const FETCH_MYNETWORK_REQUEST = 'FETCH_MYNETWORK_REQUEST';
export const FETCH_MYNETWORK_SUCCESS = 'FETCH_MYNETWORK_SUCCESS';
export const FETCH_MYNETWORK_FAILURE = 'FETCH_MYNETWORK_FAILURE';
export const CREATE_MYNETWORK_REQUEST = 'CREATE_MYNETWORK_REQUEST';
export const CREATE_MYNETWORK_SUCCESS = 'CREATE_MYNETWORK_SUCCESS';
export const CREATE_MYNETWORK_FAILURE = 'CREATE_MYNETWORK_FAILURE';
